// Configurations URL
export const APP_URL = process.env.REACT_APP_URL
export const APP_URL_API = process.env.NODE_ENV === "production" ?  process.env.REACT_APP_URL_API : "http://localhost:3000"